export enum EpisodeCategory {
    allergology = 'allergology',
    allergy = 'allergy',
    audiology = 'audiology',
    bariatrics = 'bariatrics',
    cardiology = 'cardiology',
    corona = 'corona',
    dermatology = 'dermatology',
    endocrinology = 'endocrinology',
    general = 'general',
    homeconsultation = 'homeconsultation',
    mentalHealth = 'mentalHealth',
    nephrology = 'nephrology',
    neurology = 'neurology',
    ophthalmology = 'ophthalmology',
    orthopedics = 'orthopedics',
    pilot = 'pilot',
    pulmonology = 'pulmonology',
    radiology = 'radiology',
    somnology = 'somnology',
    specialistConsultation = 'specialistConsultation',
}
